// extracted by mini-css-extract-plugin
export var askAiIcon = "_o7-j";
export var category = "_o7-9";
export var categoryHeader = "_o7-e";
export var container = "_o7-0";
export var group = "_o7-a";
export var groupItems = "_o7-f";
export var groupSeparator = "_o7-k";
export var loading = "_o7-1";
export var noResults = "_o7-3";
export var placeholder = "_o7-2";
export var resultContent = "_o7-5";
export var resultIcon = "_o7-c";
export var resultItem = "_o7-g";
export var resultMeta = "_o7-8";
export var resultSubtitle = "_o7-7";
export var resultSuffix = "_o7-i";
export var resultTitle = "_o7-6";
export var resultsList = "_o7-4";
export var searchGroup = "_o7-d";
export var selected = "_o7-h";
export var subgroup = "_o7-b";